import * as requests from 'api/requests';

import appInsights from '../appInsights';

export const TrackBulkUpload = (tableName, userName, email) => {
  appInsights.trackEvent({
    name: "Bulk Upload",
    properties: {
      tableName: tableName || "Error",
      name: userName ? userName : "Anonymous",
      email: email ? email : "Anonymous"
    }
  });

  // We need to store each entry of the bulk upload separately but that might be better done from the 
  // function vs here.  
  requests.captureAnalyticsEvent({
    eventType: "Bulk Upload",
    siteId: "Unknown"
  });
}

export const TrackLinkClick = (siteId, dashboardId, userName, linkId, email) => {
  appInsights.trackEvent({
    name: "Link Clicked",
    properties: {
      siteId: siteId || "Unknown",
      dashboardId: dashboardId || "Unknown",
      name: userName ? userName : "Anonymous",
      linkId: linkId ? linkId : "Unknown",
      email: email ? email : "Anonymous"
    }
  });

  requests.captureAnalyticsEvent({
    eventType: "Link Clicked",
    siteId: siteId
  });
}

export const TrackLinkRequest = (siteId, dashboardId, owner_email) => {
  appInsights.trackEvent({
    name: "Link Request Submitted",
    properties: {
      siteId: siteId,
      dashboardId: dashboardId,
      owner_email: owner_email
    }
  });

  requests.captureAnalyticsEvent({
    eventType: "Link Request Submitted",
    siteId: siteId
  });
}

export const TrackDashboardAdd = (siteId) => {
  appInsights.trackEvent({
    name: "Dashboard Added",
    siteId: siteId
  });

  requests.captureAnalyticsEvent({
    eventType: "Dashboard Added",
    siteId: siteId
  });
}

export const TrackDashboardEdit = (siteId, dashboardId) => {
  appInsights.trackEvent({
    name: "Dashboard Edited",
    properties: {
      siteId: siteId,
      dashboardId: dashboardId,
    }  });

  requests.captureAnalyticsEvent({
    eventType: "Dashboard Edited",
    siteId: siteId
  });
}

export const TrackDashboardDelete = (siteId, dashboardId) => {
  appInsights.trackEvent({
    name: "Dashboard Deleted",
    properties: {
      siteId: siteId,
      dashboardId: dashboardId,
    }
  });

  requests.captureAnalyticsEvent({
    eventType: "Dashboard Deleted",
    siteId: siteId
  });
}

export const TrackLinkAdd = (siteId, dashboardId, category) => {
  appInsights.trackEvent({
    name: "Link Added",
    properties: {
      siteId: siteId,
      dashboardId: dashboardId,
      category: category
    }
  });

  requests.captureAnalyticsEvent({
    eventType: "Link Added",
    siteId: siteId
  });
}

export const TrackLinkEdit = (siteId, dashboardId, category) => {
  appInsights.trackEvent({
    name: "Link Edited",
    properties: {
      siteId: siteId,
      dashboardId: dashboardId,
      category: category
    }
  });
  requests.captureAnalyticsEvent({
    eventType: "Link Edited",
    siteId: siteId
  });
}

export const TrackLinkDelete = (siteId, dashboardId, category) => {
  appInsights.trackEvent({
    name: "Link Deleted",
    properties: {
      siteId: siteId,
      dashboardId: dashboardId,
      category: category
    }
  });

  requests.captureAnalyticsEvent({
      eventType: "Link Deleted",
      siteId: siteId
  });
}

export const TrackQRPrint = (siteId, dashboardId, userName, email) => {
  appInsights.trackEvent({
    name: "QR Code Print Click",
    properties: {
      siteId: siteId || "Unknown",
      dashboardId: dashboardId || "Unknown",
      name: userName ? userName : "Anonymous",
      email: email ? email : "Anonymous"
    }
  });

  requests.captureAnalyticsEvent({
    eventType: "QR Code Print Clicked",
    siteId: siteId
  });
}

export const TrackQRScan = (location, siteId, dashboardId, userName) => {
  const useQuery = new URLSearchParams(location.search);
  const isQR = useQuery.get("qrcode");

  if (isQR) {
    appInsights.trackEvent({
      name: "QR Code Scanned",
      properties: {
        siteId,
        dashboardId,
        userName
      },
    });

    requests.captureAnalyticsEvent({
      eventType: "QR Code Scanned",
      siteId: siteId
    });
  }
}

export const TrackGetQRClick = (siteId, dashboardId, userName) => {
  appInsights.trackEvent({
    name: "Get QR Button Clicked",
    properties: {
      siteId,
      dashboardId,
      userName
    },
  });

  requests.captureAnalyticsEvent({
    eventType: "Get QR Button Clicked",
    siteId: siteId
  });
}

export const TrackDashboardView = (siteId, dashboardId, userName) => {
  appInsights.trackEvent({
    name: "Dashboard Viewed",
    properties: {
      siteId,
      dashboardId,
      userName
    },
  });

  requests.captureAnalyticsEvent({
    eventType: "Dashboard Viewed",
    siteId: siteId
  });
}

export const TrackFilterClick = (siteId, filterValue, userName, email) => {
  appInsights.trackEvent({
    name: "Filter Click",
    properties: {
      siteId: siteId,
      filterValue: filterValue,
      name: userName ? userName : "Anonymous",
      email: email ? email : "Anonymous"
    }
  });
}

export const TrackFeedback = (siteId, dashboardId, linkId, userName, email) => {
  appInsights.trackEvent({
    name: "Feedback Given",
    properties: {
      siteId: siteId || "Unknown",
      dashboardId: dashboardId ? dashboardId : "Unknown",
      linkId: linkId ? linkId : "Unknown",
      name: userName ? userName : "Anonymous",
      email: email ? email : "Anonymous"
    }
  });

  requests.captureAnalyticsEvent({
    eventType: "Feedback Given",
    siteId: siteId
  });
}

export const TrackAppFeedback = () => {
  appInsights.trackEvent({
    name: "AppFeedback",
  })
}

export const TrackPageView = (pathname, userName, email) => {
  let pathArray = pathname.split("/")
  let route = pathArray[1];
  let page = "";
  let properties = {
    name: userName ? userName : "Anonymous",
    email: email ? email : "Anonymous",
  };
  switch (route) {
    case "":
      page = "Home";
      break;
    case "help":
      page = "Help";
      break;
    case "browse":
      page = "Browse";
      break;
    case "managerportal":
      page = "Manager Portal";
      break;
    case "site":
      properties["siteId"] = pathArray[2];
      properties["dashboardId"] = pathArray[4];
      if (pathArray[pathArray.length - 1] === "qr-code") {
        page = "QR Code";
      } else {
        page = "Dashboard";
      }
      break;
    default:
      page = "other";
      properties["path"] = pathname;
  }

  appInsights.trackPageView({
    name: page,
    properties
  })
}